import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";

const blogPosts = [
  {
    date: "3 May 2025",
    title: "Democratizing Legal Relief: How AI Tools Are Transforming Legal Drafting",
    excerpt: "Discover LegalApp’s new AI-powered feature that drafts precise, well-reasoned applications. Save time, overcome language barriers, and strengthen your legal strategy with a click.",
    route: "/blogs/ai-applications"
  },
  {
    date: "28 April 2025",
    title: "The Crucial Role of Proper Police Investigation in Matrimonial FIRs",
    excerpt: "Proper police investigation in matrimonial FIRs can make or break a case — saving years of litigation or ensuring timely justice. This article explains why a diligent investigation is crucial, what the law says about examining  the complainant, witnesses, and accused, and how parties can protect their rights...",
    route: "/blogs/proper-police-investigation"
  },
  {
    date: "26 April 2025",
    title: "Not Every Failed Marriage Is a Crime",
    excerpt: "Disagreements and conflicts are a natural part of marriage. But not every broken relationship is a crime. This article explains when legal action is necessary...",
    route: "/blogs/failed-marriage-not-crime"
  },
  {
    date: "22 April 2025",
    title: "Criminal Case Proceedings in India: What to Expect – A Guide for Accused and Complainants",
    excerpt: "A step-by-step guide for both complainants and accused on how criminal trials work in India. Understand FIR, bail, trial, and post-trial rights...",
    route: "/blogs/criminal-case-guide"
  },
];

const BlogLandingPage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      minHeight: "100vh",
      backgroundColor: "white",
      color: "black",
      fontFamily: "Arial, sans-serif"
    }}>
      <Navbar />
      <main style={{
        flex: "1",
        padding: "40px 20px",
        maxWidth: "900px",
        margin: "auto"
      }}>
        <h2 style={{ marginTop: "40px", marginBottom: "40px", textAlign: "center" }}>Blogs</h2>
        {blogPosts.map((post, index) => (
          <div
            key={index}
            style={{
              marginBottom: "40px",
              borderBottom: "1px solid #e0e0e0",
              paddingBottom: "20px"
            }}
          >
            <p style={{ textTransform: "uppercase", color: "#666", fontSize: "14px", marginBottom: "8px" }}>{post.date}</p>
            <h3
              onClick={() => navigate(post.route)}
              style={{ cursor: "pointer", color: "#094268", marginBottom: "10px" }}
            >
              {post.title}
            </h3>
            <p style={{ fontSize: "16px", color: "#333" }}>{post.excerpt}</p>
          </div>
        ))}
      </main>
      <Footer />
    </div>
  );
};

export default BlogLandingPage;
